import React, { Component } from "react";
import {   Row, Card , Label, Button,FormGroup  , Input } from "reactstrap";
 
import { connect } from "react-redux";
import { registerUser } from "../../redux/actions";
 
// import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";
import axios from "../../containers/api";
 
import {  toEnglishNumbers } from "../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";
class RegisterDriver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SendActiveCode: true, 
      CheckActiveCode: false, 
      IsActive: false, 
      CardNumber: "",
      ActiveCode: "",
      Register: false, 
      MeliCode: "", 
      newMemberUsername: "",
      newMemberPassword: "",
        showNewMember: false,
        errors: [],
        Mobile: (this.props.location.state !== undefined && this.props.location.state !== null) ? (this.props.location.state[0].mobile !== null && this.props.location.state[0].mobile !== undefined) ? this.props.location.state[0].mobile : null : null,
      };
     // console.log("test")
  }
  onUserRegister() {
    if (this.state.email !== "" && this.state.password !== "") {
      this.props.history.push("/");
    }
    }
    componentWillMount() {
        
    }
   
 
validateInputData = () => {
  //this.props.closeSweetAlert();
  let error = [];
     
  if (this.state.MeliCode.length < 10 ) {
      error.push("کد ملی نباید کمتر از ۱۰ حرف باشد.");
  }
  if (this.state.CardNumber.length === 0) {
      error.push("وارد كردن شماره هوشمند خودرو الزامی میباشد.");
  }
 
   

  this.setState({errors: error});
  if (error.length === 0) {
      this.AddProductOwner();
  } else {
      
      this.props.showAlert(error, "error");
  }
};

AddProductOwner= () => {
  const addModel = {
     
      nationalId: toEnglishNumbers(this.state.MeliCode),  
      carSmartCard: toEnglishNumbers(this.state.CardNumber), 
      mobile: toEnglishNumbers(this.state.Mobile), 
  };

  //this.props.showSpinner();
    axios.post('api/v1/Driver/RegisterDriverInfo', addModel)
      .then((res) => {
          //this.props.hideSpinner();
          if (res.status === 200 && res.data.data  !== null) {
              //console.log(res.data);
              this.setState({
                  newMemberUsername: "D"+res.data.data.data.nationalId,
                  newMemberPassword: res.data.data.data.password,
                  Register: false,
                  showNewMember: true
              });
          }
          else {
              this.props.showAlert(res.data.errors[0], "error");  
          }
      })
      .catch((error) => {
          //this.props.hideSpinner();
          //this.props.showAlert(showCatchError(error), "error");
          console.log(error.response);
      });
};

 
  render() {
    return (
      <Row className="justify-content-center align-items-center d-flex mt-5">
      <Colxx xxs="12" md="8">
        <Card className="auth-card">
          <div className="form-side justify-content-center align-items-center d-flex flex-column">
            <div className="logo-single mb-2"/>
           

                        
                        
                        <div className="flex-column w-100 justify-content-center">
                            
                        <FormGroup className="w-md-50 w-100 mx-1">
                        <Label>شماره هوشمند خودرو</Label>
                        <Input value={this.state.CardNumber} maxLength={11}
                               onChange={(e) => this.setState({ CardNumber: e.target.value })}/>
                    </FormGroup>
                    
                    <FormGroup className="w-md-50 w-100 mx-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.MeliCode} maxLength={11}
                               onChange={(e) => this.setState({ MeliCode: e.target.value })}/>
                    </FormGroup>
                    

                   
                    <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.validateInputData()}>
                                 ثبت نام
                            </Button>
                            
                            <Link to={"/"} type="button">
                                <Button outline color="warning" className="mx-3 my-md-0 my-1">
                                    ورود به پنل
                                </Button>
                            </Link>
                            
                        </div>
                     
                     {this.state.showNewMember === true &&
                    <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                        <FormGroup className="w-md-50 w-100 mx-1">
                            <Label> نام کاربری</Label>
                            <Input value={this.state.newMemberUsername} disabled onChange={(e) => this.setState({ newMemberUsername: e.target.value })} />
                        </FormGroup> 
                        <FormGroup className="w-md-50 w-100 mx-1">
                            <Label> کلمه عبور</Label>
                            <Input value={this.state.newMemberPassword} disabled onChange={(e) => this.setState({ newMemberPassword: e.target.value })} />
                        </FormGroup> 
                    </div>
                    }
            </div>
            </Card>
          </Colxx>

  
            
      
      </Row>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(
  mapStateToProps,
  {
    registerUser
  }
)(RegisterDriver);
